module.exports = __webpack_public_path__ + "img/option_icon.96859122.svg";